<template>
  <div class="List">
    <van-nav-bar
      title="客户"
      fixed
      placeholder
      :z-index="10"
      left-arrow
      @click-left="onClickLeft"
    >
    </van-nav-bar>
    <van-search
      v-model="filter.name"
      show-action
      background="#fff"
      placeholder="请输入客户名称"
      @search="onSearch"
    >
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        class="list-box"
      >
        <CaseItem
          v-for="(item, index) in list"
          :item="item"
          :key="index"
          :userInfo="userBaseInfo.resOperatorDTO"
          class="item"
          @actionClick="onActionClick"
        ></CaseItem>
      </van-list>
    </van-pull-refresh>
    <div class="bottom-btn">
      <div class="btns">
        <van-button
          round
          type="info"
          @click="$router.push('/list/create?type=user')"
          >新增客户</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Search } from "vant";
import { Icon } from "vant";
import { Tabbar, TabbarItem } from "vant";
import Vue from "vue";
Vue.use(Search, Icon);
Vue.use(Tabbar);
Vue.use(TabbarItem);
import Api from "@/api/user";
import popupFormMixin from "@/mixins/popupFormMixin";

import { Toast } from "vant";
export default {
  mixins: [popupFormMixin],
  props: {},
  components: {},
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      filter: {},
      pageNo: 1,
      pageSize: 10,
    };
  },
  methods: {
    handelTab() {
      const parameterUrl = this.$router.resolve({
        name: this.$route.name,
        query: {
          ...this.filter,
        },
      }).href;
      history.replaceState(null, null, parameterUrl);
      this.onRefresh();
    },
    onSearch() {
      this.pageNo = 1;
      this.list = [];
      this.onLoad();
    },
    onSerachClick() {
      this.$router.push({
        name: "search",
      });
    },
    async onLoad() {
      try {
        this.finished = false;
        this.loading = true;
        const { pageNo, pageSize, filter } = this;
        const params = {
          pageNo,
          pageSize,
          ...filter,
        };
        if (params.statusEq == "ALL") {
          delete params.statusEq;
        }
        var res = await Api.getCustomerList(params);
        const { data } = res;
        const { list } = data;
        if (this.pageNo == 1) {
          this.list = list;
        } else {
          this.list = [...this.list, ...list];
        }
        this.finished = !data.isNextPage;
        this.pageNo++;
      } catch (error) {
        Toast.fail(error);
        this.list = [];
        this.finished = true;
      } finally {
        this.loading = false;
        this.refreshing = false;
      }
    },
    onRefresh() {
      this.pageNo = 1;
      this.onLoad();
    },
  },
};
</script>

<style lang="less" scoped>
.List {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.van-tabs {
  /deep/ .van-tabs__line {
    background: #3c86ff !important;
    height: 2px !important;
    width: 4em !important;
  }
}

.list-box {
  padding: 10px 12px;

  .item {
    margin-bottom: 15px;
  }
}
</style>
